var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3f3e3e",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 13.6h-.632l-.224-.216c.784-.912 1.256-2.096 1.256-3.384 0-2.872-2.328-5.2-5.2-5.2-2.872 0-5.2 2.328-5.2 5.2 0 2.872 2.328 5.2 5.2 5.2 1.288 0 2.472-.472 3.384-1.256l.216.224v.632l4 3.992 1.192-1.192-3.992-4zm-4.8 0c-1.992 0-3.6-1.608-3.6-3.6S8.008 6.4 10 6.4s3.6 1.608 3.6 3.6-1.608 3.6-3.6 3.6z",
    transform: "translate(-1243 -299) translate(385 177) translate(0 115) translate(849) translate(9 7.714)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchDark);
export default __webpack_public_path__ + "static/media/icon-search-dark.6dd89bc8ce3731e2d54423665cb8922c.svg";
export { ForwardRef as ReactComponent };